var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpWarningFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 11.4821,
    rx: 9,
    ry: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.48212C14.7848 1.48212 17.4555 2.58836 19.4246 4.5575C21.3938 6.52663 22.5 9.19734 22.5 11.9821C22.5 14.7669 21.3938 17.4376 19.4246 19.4067C17.4555 21.3759 14.7848 22.4821 12 22.4821C9.21523 22.4821 6.54451 21.3759 4.57538 19.4067C2.60625 17.4376 1.5 14.7669 1.5 11.9821C1.5 9.19734 2.60625 6.52663 4.57538 4.5575C6.54451 2.58836 9.21523 1.48212 12 1.48212V1.48212ZM12 5.98212C11.8096 5.98195 11.6212 6.02151 11.4469 6.09826C11.2726 6.17502 11.1162 6.28727 10.9878 6.42787C10.8593 6.56846 10.7616 6.7343 10.7009 6.91479C10.6401 7.09529 10.6177 7.28647 10.635 7.47612L11.1825 13.4851C11.2037 13.6871 11.299 13.8742 11.45 14.0101C11.6009 14.146 11.7969 14.2212 12 14.2212C12.2031 14.2212 12.3991 14.146 12.55 14.0101C12.701 13.8742 12.7963 13.6871 12.8175 13.4851L13.3635 7.47612C13.3808 7.28659 13.3584 7.09554 13.2978 6.91515C13.2371 6.73476 13.1395 6.56899 13.0112 6.42842C12.8829 6.28785 12.7267 6.17556 12.5526 6.09872C12.3785 6.02187 12.1903 5.98216 12 5.98212V5.98212ZM12 17.9821C12.3183 17.9821 12.6235 17.8557 12.8485 17.6306C13.0736 17.4056 13.2 17.1004 13.2 16.7821C13.2 16.4639 13.0736 16.1586 12.8485 15.9336C12.6235 15.7085 12.3183 15.5821 12 15.5821C11.6817 15.5821 11.3765 15.7085 11.1515 15.9336C10.9264 16.1586 10.8 16.4639 10.8 16.7821C10.8 17.1004 10.9264 17.4056 11.1515 17.6306C11.3765 17.8557 11.6817 17.9821 12 17.9821V17.9821Z",
    fill: "#A90A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpWarningFilled);
export default __webpack_public_path__ + "static/media/ep_warning-filled.ffc95d8b85dca7c761388d0e85df3930.svg";
export { ForwardRef as ReactComponent };